import { action } from 'satcheljs';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

/**
 * This action will update the user's info in store.
 * @param userMailboxWrapper Value of user mailbox info object.
 */
export const populateUserMailboxInfo = action(
    'populateUserMailboxInfo',
    (userMailboxWrapper: EmailAddressWrapper) => ({
        userMailboxWrapper,
    })
);

/**
 * This action will reset whole store
 */
export const onDismissed = action('ON_DISMISSED');
